export class TotalWorkTime {
    public days: number;
    public hours: number;
    public milliseconds: number;
    public minutes: number;
    public seconds: number;
    public ticks: number;
    public totalDays: number;
    public totalHours: number;
    public totalMilliseconds: number;
    public totalMinutes: number;
    public totalSeconds: number;

    constructor();
    constructor(json: any)
    constructor(json?: TotalWorkTime) {
        if (json) {
            this.days = json.days;
            this.hours = json.hours;
            this.milliseconds = json.milliseconds;
            this.minutes = json.minutes;
            this.seconds = json.seconds;
            this.ticks = json.ticks;
            this.totalDays = json.totalDays;
            this.totalHours = json.totalHours;
            this.totalMilliseconds = json.totalMilliseconds;
            this.totalMinutes = json.totalMinutes;
            this.totalSeconds = json.totalSeconds;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/total-work-time.ts